import {Component, forwardRef, HostBinding, Input, Injectable, Output,EventEmitter} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import {NgbDate} from "@ng-bootstrap/ng-bootstrap/datepicker/ngb-date";
import {
  NgbDateStruct, NgbCalendar, NgbCalendarIslamicUmalqura, NgbDatepickerI18n
} from '@ng-bootstrap/ng-bootstrap';

const noop = () => {
};

const I18N_VALUES = {
  weekdays: ['ن', 'ث', 'ر', 'خ', 'ج', 'س', 'ح'],
  months: ['محرم', 'صفر', 'ربيع الأول', 'ربيع الآخر', 'جمادى الأولى', 'جمادى الآخرة', 'رجب', 'شعبان', 'رمضان', 'شوال',
    'ذو القعدة', 'ذو الحجة']
};

const equals = (one: NgbDateStruct, two: NgbDateStruct) =>
  one && two && two.year === one.year && two.month === one.month && two.day === one.day;

const before = (one: NgbDateStruct, two: NgbDateStruct) =>
  !one || !two ? false : one.year === two.year ? one.month === two.month ? one.day === two.day
    ? false : one.day < two.day : one.month < two.month : one.year < two.year;

const after = (one: NgbDateStruct, two: NgbDateStruct) =>
  !one || !two ? false : one.year === two.year ? one.month === two.month ? one.day === two.day
    ? false : one.day > two.day : one.month > two.month : one.year > two.year;


@Injectable()
export class IslamicI18n extends NgbDatepickerI18n {

  getWeekdayShortName(weekday: number) {
    return I18N_VALUES.weekdays[weekday - 1];
  }

  getMonthShortName(month: number) {
    return I18N_VALUES.months[month - 1];
  }

  getMonthFullName(month: number) {
    return this.getMonthShortName(month);
  }
}

@Component({
  selector: 'app-date-range',
  templateUrl: './app-date-range.component.html',
  styleUrls: ['./app-date-range.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AppDateRangeComponent),
      multi: true
    }
  ]
})
export class AppDateRangeComponent implements ControlValueAccessor {
  @Input() disabled = false;
  hijricalender: NgbCalendarIslamicUmalqura = new NgbCalendarIslamicUmalqura();
  model: NgbDateStruct;
  date: { year: number, month: number };
  selectdate='';
  otherdate='';
  datetype = 1;
  rangeDate:any;
  hoveredDate: NgbDateStruct;

  fromDate: NgbDateStruct;
  toDate: NgbDateStruct;

  constructor(private calendar: NgbCalendar) { }

  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;

  get value(): any {
    return this.selectdate;
  }

  onBlur() {
    this.onTouchedCallback();
  }

  changedate() {
    this.fromDate = this.rangeDate.fromDate;
    this.toDate = this.rangeDate.toDate;
    this.returneddate();

  }

  onDateChange(date: NgbDateStruct) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate && after(date, this.fromDate)) {
      this.toDate = date;
      this.returneddate()
    } else {
      this.toDate = null;
      this.fromDate = date;
    }
  }

  returneddate() {
    const NselectFromdate = this.fromDate.year+'-'+this.fromDate.month+'-'+this.fromDate.day;
    const NselectTodate = this.toDate.year+'-'+this.toDate.month+'-'+this.toDate.day;
    if(this.datetype === 2) {
      this.otherdate = NselectFromdate+' - '+NselectTodate;
      const ngbFromdate:NgbDate = new NgbDate(this.fromDate.year,this.fromDate.month,this.fromDate.day);
      const convertFromDate = this.hijricalender.toGregorian(ngbFromdate);
      const newFromDate = convertFromDate.getFullYear()+'-'+(convertFromDate.getMonth()+1)+'-'+convertFromDate.getDate();
      const ngbTodate:NgbDate = new NgbDate(this.toDate.year,this.toDate.month,this.toDate.day);
      const convertToDate = this.hijricalender.toGregorian(ngbTodate);
      const newToDate = convertToDate.getFullYear()+'-'+(convertToDate.getMonth()+1)+'-'+convertToDate.getDate();
      this.writeValue( newFromDate+' - '+newToDate);
    } else {
      this.writeValue( NselectFromdate+' - '+NselectTodate);
      const convertFromDate = this.hijricalender.fromGregorian(new Date(this.fromDate.year,this.fromDate.month-1,this.fromDate.day));
      const newFromDate = convertFromDate.year+'-'+convertFromDate.month+'-'+convertFromDate.day;

      const convertToDate = this.hijricalender.fromGregorian(new Date(this.toDate.year,this.toDate.month-1,this.toDate.day));
      const newToDate = convertToDate.year+'-'+convertToDate.month+'-'+convertToDate.day;

      this.otherdate = newFromDate+' - '+newToDate;
    }
  }

  writeValue(date: any) {
    this.selectdate = date;
    this.onChangeCallback(this.selectdate);
  }

  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  isHovered = date => this.fromDate && !this.toDate && this.hoveredDate && after(date, this.fromDate) && before(date, this.hoveredDate);
  isInside = date => after(date, this.fromDate) && before(date, this.toDate);
  isFrom = date => equals(date, this.fromDate);
  isTo = date => equals(date, this.toDate);

}

@Component({
  selector: 'ngbd-islamic-range-umalqura',
  templateUrl: './islamic-range.component.html',
  styleUrls: ['./app-date-range.component.scss'],
  providers: [
  {provide: NgbCalendar, useClass: NgbCalendarIslamicUmalqura},
  {provide: NgbDatepickerI18n, useClass: IslamicI18n}

]
})
export class NgbdIslamicRangeUmalqura extends AppDateRangeComponent {
  name = 'Umalqura';
  @Input() getDate: NgbDateStruct;
  @Output() dateEmitter = new EventEmitter();
  changedate() {
    if (this.fromDate && this.toDate) {
    const rangeDate = {fromDate:this.fromDate,toDate:this.toDate};
    this.dateEmitter.next(rangeDate);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/app-date-range/app-date-range.component.ts